<i18n>
{
"en": {
  "BUSES": "Buses",
  "MANAGEBUSES": "Manage Buses",
  "ADDNEWBUS": "Add New Bus",
  "BUSNUMBER": "Bus Number",
  "MAKE": "Make",
  "MODEL": "Model",
  "YEAR": "Year",
  "PLATENUMBER": "Plate Number",
  "EXPIRATIONDATE": "Expiration Date",
  "DOCUMENTS": "Documents",
  "LABEL": "Label",
  "EDITBUS": "Edit Bus",
  "VIEW": "View",
  "UPLOADCSVFILE": "Upload CSV File",
  "CHOOSEFILTERBY": "Choose Filer By",
  "SEARCHMODEL": "Search Model",
  "SEARCHPLATE": "Search Plate",
  "SEARCHBUS": "Search Bus",
  "LOADING": "Loading...",
  "SEATS": "Seats",
  "STATUS": "Status",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "DEACTIVATEBUS": "Deactivate Bus",
  "ACTIVATEBUS": "Activate Bus",
  "AREYOUSUREYOUWANTTO": "Are you sure you want to",
  "RESTORETHISBUS": "restore this bus?",
  "DEACTIVATETHISBUS": "deactivate this bus?",
  "CANCEL": "Cancel",
  "CONFIRM": "Confirm",
  "BUSCANNOTBEDEACTIVATED": "Bus cannot be deactivated! Already assigned to a route.",
  "BUSHASBEEN": "Bus has been",
  "RESTORED": "restored!",
  "DEACTIVATED": "deactivated!",
  "BUSCANNOTBEENDELETED": "Bus cannot been deleted!",
  "ASSIGNEDTOBUS": "Assigned to route",
  "ASSIGNED": "Assigned",
  "NOTASSIGNED":"Not assigned",
  "ROUTENAME": "Route Name",
  "FILTERBYROUTE": "Filter by route"
},
"ar": {
  "BUSES": "الحافلات",
  "MANAGEBUSES": "إدارة الحافلات",
  "ADDNEWBUS": "إضافة ا حافلة جديدة",
  "BUSNUMBER": "رقم الحافلة",
  "MAKE": "الصنع",
  "MODEL": "النوع",
  "YEAR": "السنة",
  "PLATENUMBER": "رقم الوحة",
  "EXPIRATIONDATE": "تاريخ الإنتهاء",
  "DOCUMENTS": "الوثائق",
  "LABEL": "الاسم",
  "EDITBUS": "تحرير الحافلة",
  "VIEW": "عرض",
  "UPLOADCSVFILE": "تحميل ملف CSV",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "SEARCHMODEL":"ابحث عن النوع",
  "SEARCHPLATE": "ابحث عن لوحة الترخيص",
  "SEARCHBUS": "ابحث عن الحافلة",
  "LOADING": "جار التحميل...",
  "SEATS": "مقاعد",
  "STATUS": "الحالة",
  "ACTIVE": "مفعل",
  "INACTIVE": "غير مفعل",
  "DEACTIVATEBUS": "تعطيل الحافلة ",
  "ACTIVATEBUS": " تفعيل الحافلة ",
  "AREYOUSUREYOUWANTTO": "هل أنت متأكد أنك تريد",
  "RESTORETHISBUS": "استعادة هذا الحافلة",
  "DEACTIVATETHISBUS": "إلغاء تنشيط هذا الحافلة؟",  
  "DEACTIVATEBUS": " تعطيل الحافلة ؟",
  "CANCEL": "الغاء",
  "CONFIRM": "تأكد",
  "BUSCANNOTBEDEACTIVATED": " .لا يمكن تعطيل !الحافلة لديها طريق مخصص",
  "BUSHASBEEN": "وكانت الحافلة",
  "RESTORED": "رمم!",
  "DEACTIVATED": "معطلة!",
  "BUSCANNOTBEENDELETED": "لا يمكن حذف الحافلة!",
  "ASSIGNEDTOBUS": "مشارك في الطريق",
  "ASSIGNED": "مشارك",
  "NOTASSIGNED":"غيرمشارك",
  "ROUTENAME": "اسم المسار",
  "FILTERBYROUTE": "اختر حسب خط السير"
}
}
</i18n>
<template>
  <div>
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{$t('MANAGEBUSES')}}</span>
        <el-dropdown trigger="click" type="dark">
          <el-button-group>
            <el-button @click="$router.push({path:'/transportation/bus/create'})" :disabled="!isAllowed('save')">
               <i class="el-icon-plus"></i> {{$t('ADDNEWBUS')}}
            </el-button>
            <el-button ref="trigger" class="el-dropdown__caret-button">
              <i class="el-dropdown__icon el-icon-caret-bottom"></i>
            </el-button>
          </el-button-group>
          <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :disabled="!isAllowed('import')">       
          <el-upload
            ref="upload"
            accept=".csv"
            class="upload-demo"
            :action="URL + 'media/upload'"
            :data="import_data"
            :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
            :with-credentials="true"
            :on-success="uploadedFile">
            <i class="fa fa-upload"></i> {{$t('UPLOADCSVFILE')}}
          </el-upload>   
          </el-dropdown-item>
        </el-dropdown-menu>
        </el-dropdown>      
      </div>

      <div class="filters" ref="filter">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-select v-model="filter" @change="changedFilter" :placeholder="$t('CHOOSEFILTERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-if="active_filter=='model'">
            <el-input :placeholder="$t('SEARCHMODEL')" v-model="Model" :icon="Model ? 'circle-close' : ''" @click="clearInput"></el-input>
          </el-col>         
          <el-col :span="4" v-if="active_filter=='label'">
            <el-input :placeholder="$t('SEARCHBUS')" v-model="Label" :icon="Label ? 'circle-close' : ''" @click="clearInput"></el-input>
          </el-col>          
          <el-col :span="4" v-if="active_filter=='plate'">
            <el-input :placeholder="$t('SEARCHPLATE')" v-model="Plate" :icon="Plate ? 'circle-close' : ''" @click="clearInput"></el-input>
          </el-col>                              
        </el-row>
      </div>
      <el-table
       v-loading="loading"    
        :element-loading-text="$t('LOADING')"
        :data="listBuses"
        highlight-current-row
        @current-change="handleCurrentChange"
        :height="tableHeight"
        stripe
        style="width: 100%">
        <el-table-column
          prop="Label"
          :label="$t('BUSNUMBER')"
          min-width="130"
          class="center"
          align="left"
          sortable>
        </el-table-column>
        <el-table-column
          prop="Model"
          :label="$t('MODEL')"
          min-width="100"
          align="left"
          sortable>
        </el-table-column>
        <el-table-column
          prop="Year"
          :label="$t('YEAR')"
          min-width="90"
          align="center"
          sortable>
        </el-table-column>
        <el-table-column
          prop="Plate"
          :label="$t('PLATENUMBER')"
          min-width="140"
          align="center"
          sortable>
        </el-table-column>

        <el-table-column
          prop="MaxSeats"
          :label="$t('SEATS')"
          align="center"
          min-width="90"
          sortable>
        </el-table-column>

        <el-table-column
          prop="RegistrationExpiration"
          :label="$t('EXPIRATIONDATE')"
          min-width="150"
          align="center"
          sortable>
        </el-table-column>
        <el-table-column align="center" :label="$t('DOCUMENTS')" min-width="110">
            <template slot-scope="scope">
               <el-button :disabled="checkToView(scope.row.Documents)" size="small" @click="openSlider(scope.row)"><i class="fa fa-sticky-note"></i> {{$t('VIEW')}}</el-button>
            </template>
        </el-table-column>
        <el-table-column
          prop="Status"
          :label="$t('STATUS')"
          align="center"
          min-width="95"
          sortable>

          <template slot-scope="scope">
              <el-tag
                :type="parseInt(scope.row.Status) !== 1  ? 'success' : 'danger'"
                close-transition>{{parseInt(scope.row.Status) !== 1 ? $t('ACTIVE') : $t('INACTIVE')}}</el-tag>
          </template>

        </el-table-column>


         <el-table-column
            :label="$t('ASSIGNEDTOBUS')"
            min-width="165"
            align="center"
            sortable>
            <template slot-scope="scope">
              <el-tag
                type="primary"
                close-transition>{{scope.row.RouteID !== null ? $t('ASSIGNED') : $t('NOTASSIGNED')}}</el-tag>
            </template>
          </el-table-column>
        <el-table-column
          align="center"
          class="actions"
          min-width="80">
          <template slot-scope="scope">
              <el-tooltip v-if="isAllowed('save')" :content="$t('EDITBUS')" placement="top">
                <el-button type="text" @click="$router.push({path:'/transportation/bus/'+scope.row.BusID})"><i class="fa fa-pencil"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="isAllowed('delete')" :disabled="scope.row.RouteID!=null ? true : false" :content="buses[scope.$index].Status==0 ? $t('DEACTIVATEBUS') : $t('ACTIVATEBUS')" placement="top">            
              <el-popover
                trigger="manual"
                placement="left"
                width="160"
                @show="bus=buses[scope.$index]"
                v-model="buses[scope.$index].Deleted">
                <p>{{$t('AREYOUSUREYOUWANTTO') + ' '}}{{buses[scope.$index].Status==0 ? $t('DEACTIVATETHISBUS') : $t('RESTORETHISBUS')}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="buses[scope.$index].Deleted = false">{{$t('CANCEL')}}</el-button>
                  <el-button type="primary" size="mini" @click="toggleStatus(scope.$index)">{{$t('CONFIRM')}}</el-button>
                </div>
                <el-button :disabled="scope.row.RouteID!=null" style="margin-left:10px" type="text" @click="buses[scope.$index].Deleted=true" slot="reference"><i class="fa" :class="[scope.row.Status!= 0 ? 'fa-undo' : 'fa-times']"></i> </el-button>
              </el-popover>
              </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-doc-dialog :visible.sync="dialogVisible" :document="bus.Documents"></el-doc-dialog>
      <el-import-dialog @reCall="reCall" :visible.sync="dialogImport" :fields="fields" :title="$t('BUSES')" uri="bus/import" :CSVReader="CSVReader" :CSVFile="CSVFile"></el-import-dialog>      
    </el-card>
  </div>
</template>

<script>
  
  import _ from 'lodash'
  import DocDialog from '@/components/dialogs/Doc'
  import ImportDialog from '@/components/dialogs/Import'
  export default {
    components: {'el-doc-dialog': DocDialog, 'el-import-dialog': ImportDialog},
    data () {
      return {
        buses: [],
        bus: {Deleted: false, Documents: []},
        currentRow: null,
        tableHeight: 0,
        filter: null,
        active_filter: 'model',
        loading: true,
        indexCheck: null,
        prevIndex: null,
        Model: '',
        Label: '',
        Plate: '',
        date_format: 'dd/MM/yyyy',
        dialogVisible: false,
        CSVReader: {},
        CSVFile: '',
        dialogImport: false,
        import_data: {}
      }
    },
    mounted () {
      this.switchLanguage()
      this.import_data = {folder: this.$route.path.split('/')[2], type: 'import'}
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + 53)
      this.getBuses()
    },
    computed: {
      listBuses () {
        let buses = this.buses
        if (_.isEmpty(buses)) return
        if (this.active_filter === 'model') buses = this.filterBy(buses, this.Model, 'Model')
        if (this.active_filter === 'label') buses = this.filterBy(buses, this.Label, 'Label')
        if (this.active_filter === 'plate') buses = this.filterBy(buses, this.Plate, 'Plate')
        return buses
      },
      options () {
        let options = [{
          value: 'model',
          label: this.$t('MODEL')
        }, {
          value: 'label',
          label: this.$t('BUSNUMBER')
        }, {
          value: 'plate',
          label: this.$t('PLATENUMBER')
        }]
        return options
      },
      fields () {
        let fields = [
          {label: this.$t('BUSNUMBER'), field: 'Label', required: true, format: null},
          {label: this.$t('MAKE'), field: 'Make', required: true, format: null},
          {label: this.$t('MODEL'), field: 'Model', required: true, format: null},
          {label: this.$t('YEAR'), field: 'Year', required: true, format: null},
          {label: this.$t('SEATS'), field: 'MaxSeats', required: true, format: null},
          {label: this.$t('PLATENUMBER'), field: 'Plate', required: true, format: null},
           {label: this.$t('EXPIRATIONDATE'), field: 'RegistrationExpiration', required: true, format: 'date'}
        ]
        return fields
      }
    },
    methods: {
      getBuses () {
        let self = this
        if (!self.loading) return
        this.$http.get('/bus')
          .then(function (response) {
            for (let bus in response.data) {
              response.data[bus].Documents = JSON.parse(response.data[bus].Documents)
              response.data[bus].Deleted = false
            }
            self.buses = response.data
            self.loading = false
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      reCall () {
        this.loading = true
        this.getBuses()
      },
      currentLang () {
        return localStorage.getItem('lang')
      },
      filterBy (arr, search, delimiter) {
        if (!search) return arr
        let res = []
        arr.filter(function (el) {
          if (typeof delimiter === 'object') {
            let regx = new RegExp('^' + search, 'i')
            if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el)
          } else {
            search = '^' + search
            if (new RegExp(search, 'i').test(el[delimiter])) res.push(el)
          }
        })
        return res
      },
      removeFilter (filter) {
        this.changeFilter()
        this.filter = ''
        this.listBuses
      },
      changeFilter () {
        this.Model = this.Label = this.Plate = ''
      },
      handleCurrentChange (val) {
        this.currentRow = val
      },
      toggleStatus (index) {
        let self = this
        let postData = {BusID: self.buses[index].BusID, Status: self.buses[index].Status}
        this.$http.post('/bus/delete', postData)
          .then(function (response) {
            self.buses[index].Deleted = false
            self.buses[index].DeletedAT = self.buses[index].DeletedAT !== null ? null : ''
            self.buses[index].Status = self.buses[index].Status === '1' ? '0' : '1'
            if (self.buses[index].Status === '1') self.buses.push(self.buses.splice(index, 1)[0])
            self.$message({
              message: response.data.error ? self.$t('BUSCANNOTBEENDELETED') : self.$t('BUSHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
              type: response.data.error ? 'error' : 'success',
              showClose: true
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      checkRoute (index) {
        let self = this
        if (self.prevIndex !== null) self.buses[self.prevIndex].Deleted = false
        if (self.indexCheck === self.buses[index].BusID) return
        this.$http.get('/route/verify' + '&BusID=' + self.buses[index].BusID + '&TourID=' + null)
          .then(function (response) {
            let result = response.data
            let Deleted = true
            if (result.error) {
              self.prevIndex = index
              Deleted = false
              self.indexCheck = self.buses[index].BusID
              let message = self.$t('BUSCANNOTBEDEACTIVATED')
              return self.$message({
                message: message,
                type: 'warning',
                showClose: true,
                onClose: function () {
                  self.indexCheck = null
                }
              })
            }
            self.buses[index].Deleted = Deleted
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      updateHeight (index) {
      },
      openSlider (bus) {
        if (typeof bus.Documents === 'string') bus.Documents = JSON.parse(bus.Documents)
        this.bus = bus
        this.dialogVisible = true
      },
      checkToView (doc) {
        if (typeof doc === 'string') doc = JSON.parse(doc)
        if (doc === null || doc.length === 0) return true
        return false
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
      },
      clearInput () {
        this.Model = this.Label = this.Plate = ''
        this.listBuses
      },
      uploadedFile (response, file, fileList) {
        if (response.error) {
          return this.$message({
            message: response.error,
            type: 'error',
            showClose: true
          })
        }
        this.CSVReader = response.fields
        this.CSVFile = response.file_name
        this.dialogImport = true
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// Bus.vue?68dd6bb2